export type notificationType = "success" | "info" | "error";

export type INotification = {
  id: string | number;
  actionType: string;
  title?: string;
  text: string;
  className?: string;
  autoCloseTime?: number;
  closable?: boolean;
  type?: notificationType;
};

export interface INotificationState {
  notificationItems: INotification[];
}

export enum NotificationType {
  Confirmation = "success",
  Info= "info",
  Error= "error"
}
